export const ID_CARD_NUMBER_MASK = '0-0000-00000-00-0';
export const LASER_NUMBER_MASK = '***-*******-**';
